// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fundo e borda do input */
.react-phone-input-2 {
  background: #23272f !important;
  border: 1px solid #444 !important;
  border-radius: 6px !important;
  color: #fff !important;
  width: 100% !important;
  font-size: 15px !important;
}

/* Input interno */
.react-phone-input-2 input,
.react-phone-input-2 input[type='tel'],
.react-phone-input-2 input[type='text'] {
  background: #23272f !important;
  color: #fff !important;
  border: none !important;
  box-shadow: none !important;
  font-size: 15px !important;
  padding-left: 48px !important; /* espaço para a bandeira */
  height: 38px !important;
}

.react-phone-input-2 input:focus {
  outline: none !important;
  box-shadow: 0 0 0 2px #1e90ff33 !important;
}

/* Dropdown de países */
.react-phone-input-2 .country-list {
  background: #23272f !important;
  color: #fff !important;
  border: 1px solid #444 !important;
}

.react-phone-input-2 .country-list .country {
  color: #fff !important;
}

.react-phone-input-2 .country-list .country .country-name {
  color: #fff !important;
}

.react-phone-input-2 .country-list .country.highlight {
  background: #2d323c !important;
}

/* Ícone da bandeira */
.react-phone-input-2 .flag-dropdown {
  background: #23272f !important;
  border-right: 1px solid #444 !important;
}

/* Placeholder */
.react-phone-input-2 input::placeholder {
  color: #aaa !important;
  opacity: 1;
}

.phone-dropdown-dark .country, .phone-dropdown-dark .country .country-name { color: #222 !important; } `, "",{"version":3,"sources":["webpack://./src/css/phone-input-dark.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;;;EAGE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B,EAAE,2BAA2B;EAC1D,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA,6EAA6E,sBAAsB,EAAE","sourcesContent":["/* Fundo e borda do input */\n.react-phone-input-2 {\n  background: #23272f !important;\n  border: 1px solid #444 !important;\n  border-radius: 6px !important;\n  color: #fff !important;\n  width: 100% !important;\n  font-size: 15px !important;\n}\n\n/* Input interno */\n.react-phone-input-2 input,\n.react-phone-input-2 input[type='tel'],\n.react-phone-input-2 input[type='text'] {\n  background: #23272f !important;\n  color: #fff !important;\n  border: none !important;\n  box-shadow: none !important;\n  font-size: 15px !important;\n  padding-left: 48px !important; /* espaço para a bandeira */\n  height: 38px !important;\n}\n\n.react-phone-input-2 input:focus {\n  outline: none !important;\n  box-shadow: 0 0 0 2px #1e90ff33 !important;\n}\n\n/* Dropdown de países */\n.react-phone-input-2 .country-list {\n  background: #23272f !important;\n  color: #fff !important;\n  border: 1px solid #444 !important;\n}\n\n.react-phone-input-2 .country-list .country {\n  color: #fff !important;\n}\n\n.react-phone-input-2 .country-list .country .country-name {\n  color: #fff !important;\n}\n\n.react-phone-input-2 .country-list .country.highlight {\n  background: #2d323c !important;\n}\n\n/* Ícone da bandeira */\n.react-phone-input-2 .flag-dropdown {\n  background: #23272f !important;\n  border-right: 1px solid #444 !important;\n}\n\n/* Placeholder */\n.react-phone-input-2 input::placeholder {\n  color: #aaa !important;\n  opacity: 1;\n}\n\n.phone-dropdown-dark .country, .phone-dropdown-dark .country .country-name { color: #222 !important; } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
